<template>
  <div class="row project-row" :class="[isExpanded ? 'expanded-row' : '', color]">
    <div class="project-color"></div>
    <div v-if="showHideIcon">
      <span style="width: 25px; position: absolute;top:0px;left:10px;z-index:7;cursor: pointer;" v-on:click="hideEmployee()">
        <i data-icon="x" class="icon" title="Skjul"></i>
      </span>
    </div>
    <div class="content-parent-row">
      <div :class="['row-info', moveTargetClass({rowData, rowDataKey})]" v-on:click="rowLabelClicked">
        <!-- Add a template with v-slot:title="" that defines the appearance of this row's title -->
        <slot name="title" :rowData="rowData"></slot>
        <i data-icon="arrow-down" class="icon row-expand-icon"></i>
      </div>

      <div class="row-drawer" v-if="showForecast">
        <div class="drawer-inner">
          <span class="warning">
            <i data-icon="exclamation" class="icon" v-if="projectOverallocations" title="Bruger/Kreds indeholder overlappende opgaver"></i>
          </span>
          <span class="future-scheduled">{{ forecastValue | nodecimalorline }}{{ (forecastValue ? forecastUnitType : '') }}</span>          
        </div>
      </div>

      <div class="row-timeline">
        
        <div class="project-grid" :class="[color]">
          <div :style="{ width: assignmentWidth(projectSpanInDays) + 'px', left: assignmentStart(projectStart) + 'px' }" class="project-span project-active">
          </div>
          <div v-for="subrow of subrowData" 
               :key="subrow[subrowKey]"
               :style="{ width: assignmentWidth(subrow[subrowDurationProp]) + 'px', left: assignmentStart(subrow[subrowStartDateProp]) + 'px' }"
               :class="[getColor(subrow)]"
               class="project-span project-assigned">
            <slot name="cell" :rowData="rowData" :subrowItem="subrow"></slot>
          </div>
        </div>

      </div>
    </div>

    <div v-if="isExpanded">

      <!-- Add a template with v-slot:expandedRows="" that contain the component generating the rows that can be expanded from this row -->
      <slot name="expandedRows" :rowData="rowData" :subrowData="subrowData" :emptyResourceRows="emptyResourceRows">
      </slot>

      <div class="content-child-row content-add-row">
        <div>
          <div class="row-info">
            <div class="content-actions-dropdown" v-show="projectId">
              <div class="dropdown-button" :class="{'is-showing': showActions}">

              </div>

            </div>

            <!-- Add a template with v-slot:expandedContent="" that contain any elements or components that should be displayed after the last subrow, when this row is expanded -->
            <slot name="expandedContent" :rowData="rowData" :addResource="addResource">
            </slot>
          </div>
          <div class="row-drawer">
            
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';

const UNIT_WIDTH = 48;

export default {
  name: 'schedule-row',
  components: { },
  props: {
    // The data object that is the basis of this row
    rowData: { type: Object, required: true },

    // Name of the property in rowData that is the primary key
    rowDataKey: { type: String, default: 'id' },

    // The dataset which will be used to build the subrows, that can be expanded from this row
    subrowData: { type: Array, default: () => ([]) },

    // The key property for subrowData entries
    subrowKey: { type: String, default: 'id' },

    // Name of the property in subrowData that holds the number of days in the period represented by the data entry
    subrowDurationProp: { type: String, default: 'allocationSpanInDays' },

    // Name of the property in subrowData, that holds the start-date for the period represented by the data entry
    subrowStartDateProp: { type: String, default: 'startDate' },

    // The start-date for the data represented by this row
    projectStart: { type: String, default: Date() },

    // The end-date for the data represented by this row
    projectEnd: { type: String, default: Date() },

    showForecast: { type: Boolean, default: false, },
    forecastValue: { type: Number },
    forecastUnit: { type: String },
    showExclamation: { type: Boolean, default: false },
    showTrash: { type: Boolean, default: true },
    overallocations: { type: Object },
    color: {
      type: String,
      default: 'black',
      validator: function (value) {
        return ['orange','green','aqua','blue','purple','magenta','red','gray','black'].indexOf(value) !== -1;
      }
    },
    milestones: {
      type: Array,
      default: () => ([])
    },
    rowType: { 
      type: String,
      default: null
    },
    filter: { type: String },
    viewStartDate: { type: Date, },
    zoomLevel: {
      type: Number,
      default: 1,
      validator: function (value) {
        // The value must be 1 or 2
        return [1,2].indexOf(value) !== -1
      },
    },
  },
  data: () => ({
    addHover: {
      addLocation: 0,
      showAdd: false,
    },
    editDialog: {
      show: false,
      currentMilestone: {},
      top: 0,
      left: 0,
    },
    emptyResourceRows: [],
    isExpanded: false,
    showActions: false,
  }),
  methods: {
    ...mapActions('allocationMoverStore', ['selectMoveTarget']),
    getColor(entry) {
      if(this.rowType && entry.circleColor) {
        if(entry.replacementId) {
          return 'green';
        }

        return entry.circleColor;
      }
       
      if(entry.allocationType === "OFFDAY" && !entry.circleId) {        
        return "yellow";
      }
      return this.color;
    },
    addMilestoneMouseDown(e) {
      this.showEdit(e, {
        name: '',
        projectId: this.projectId,
        milestoneType: 'DELIVERY_INTERNAL',
        date: this.addStartDate,
      });
      this.addHover.addInprogress = false;
    },
    addResource(resource) {
      this.emptyResourceRows.push(resource);
    },
    assignmentStart(startDate) {  
      var spanInDays = moment.utc(startDate).diff(moment.utc(this.viewStartDate), 'days');
      return spanInDays * UNIT_WIDTH / this.zoomLevel;
    },
    assignmentWidth(durationInDays) {
      return durationInDays * (UNIT_WIDTH / this.zoomLevel);
    },
    closeEdit() {
      this.editDialog.show = false;
    },
    showEdit(e, milestone) {
      this.editDialog.currentMilestone = milestone;
      this.editDialog.left = e.clientX;
      this.editDialog.top = e.clientY;
      this.editDialog.show = true;
    },
    timeLineMouseMove(e) {
      var rowOffset = e.clientX - this.firstDayOffset;      
      this.addHover.addLocation = rowOffset - (rowOffset % this.dayUnitSize);
    },
    timeLineMouseOut() {
      this.addHover.showAdd = false;
    },
    timeLineMouseOver() {
      this.addHover.showAdd = true;
    },
    toggleExpanded() {
      this.isExpanded = !this.isExpanded;
    },
    hideEmployee(){  
      if(!this.rowData || !this.rowData.number) {
        return;
      }

      let hideEmployees = [];
      if (localStorage.hideEmployees && localStorage.hideEmployees !== 'null') {
        hideEmployees = JSON.parse(localStorage.hideEmployees);
      }
      hideEmployees.push({ id: this.rowData.id, number: this.rowData.number });
      localStorage.hideEmployees = JSON.stringify(hideEmployees);
      console.log("emit: 'hideEmpolyees'");
      this.$emit('hideEmpolyees');
    },
    async rowLabelClicked() {
      if (this.awaitingSelection) {
        await this.selectMoveTarget({rowData: this.rowData, rowDataKey: this.rowDataKey, allocationRowDataKey: 'employeeId'});
      }
      else {
        this.toggleExpanded()
      }
    }
  },
  computed: {
    ...mapGetters('allocationMoverStore', ['moveTargetClass', 'awaitingSelection']),
    showHideIcon(){
      return this.rowData && this.rowData.number && this.rowData.number > 0 && this.showTrash;
    },
    dayUnitSize() {
      return UNIT_WIDTH / this.zoomLevel;
    },
    firstDayOffset() {
      return (this.showForecast ? 419 : 319);
    },
    projectId() {
      return this.rowData[this.rowDataKey];
    },
    projectMilestones() {
      return this.milestones
        .filter(a => a.projectId === this.projectId);
    },
    projectSpanInDays() {
      if (this.projectId) {
        var spanInDays = moment.utc(this.projectEnd).diff(moment.utc(this.projectStart), 'days') + 1;
        return spanInDays;
      }
      return 0;
    },
    projectOverallocations() {
      let result = null;
      if (this.overallocations && this.rowData) {
        result = this.overallocations.byEmployee[this.projectId];
        console.log(result);
      } 
      return result;
    },

  }
}
</script>

<style lang="scss">
@import '@/styles/schedulerow.scss';
</style>
